import { Injectable } from '@angular/core'

type TThemeMode = 'dark' | 'light'
@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly themeStorageKey = 'theme'
  private readonly defaultTheme = window.matchMedia(
    '(prefers-color-scheme: dark)',
  ).matches
    ? 'dark'
    : 'light'
  private htmlElement!: HTMLHtmlElement | null

  constructor() {
    this.htmlElement = document.querySelector('html')
    const savedTheme = this.getStoredTheme()
    if (this.htmlElement) {
      this.applyTheme(this.htmlElement, savedTheme)
    }
  }

  public getStoredTheme(): TThemeMode {
    return (localStorage.getItem(this.themeStorageKey) ||
      this.defaultTheme) as TThemeMode
  }

  switchTheme(): void {
    const theme = this.isDark() ? 'light' : 'dark'
    if (this.htmlElement) {
      this.applyTheme(this.htmlElement, theme)
    } else {
      console.warn('Element with id "dark-mode" not found in document.')
    }
  }

  private applyTheme(themeElement: HTMLHtmlElement, theme: TThemeMode): void {
    try {
      if (theme === 'light') {
        themeElement.classList.remove('dark-mode')
      } else {
        themeElement.classList.add('dark-mode')
      }
      this.storeTheme(theme)
    } catch (error) {
      console.error('Failed to apply theme:', error)
    }
  }

  private storeTheme(theme: string): void {
    try {
      localStorage.setItem(this.themeStorageKey, theme)
    } catch (error) {
      console.error('Failed to store theme in localStorage:', error)
    }
  }

  isDark() {
    return this.getStoredTheme() === 'dark'
  }
}
